<template>
    <v-card :dark="dark" :loading="loading" :disabled="loading">
        <v-list v-if="header">
            <v-list-item>
                <v-list-item-avatar>
                    <div>
                        <v-icon>person</v-icon>
                    </div>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-subtitle>{{ prefix }}</v-list-item-subtitle>
                    <v-list-item-title>{{ name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ suffix }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-btn icon @click="close()">
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <v-form ref="form" class="pa-3">
            <slot name="comment"></slot>
            <contact-combobox
                    hide-no-data
                    outlined
                    prependInnerIcon="person"
                    placeholder="Jméno"
                    v-model="form.name"
                    v-bind:attribute="'name'"
                    class="autoItemHeight mb-1"
                    @choose="setNumber"
                    clearable
                    :error-messages="nameErrors"
                    :disabled="!canChangeContent"
                    v-bind:autofocus="true"
            >
            </contact-combobox>

            <contact-combobox
                    hide-no-data
                    outlined
                    prependInnerIcon="phone"
                    placeholder="Číslo"
                    v-model="form.number"
                    v-bind:attribute="'number'"
                    class="autoItemHeight mb-1"
                    @choose="setName"
                    clearable
                    :error-messages="numberErrors"
                    :disabled="!canChangeContent"
            >
            </contact-combobox>
        </v-form>
        <v-card-actions>
            <v-btn block v-if="$can('create', 'EventContact') && isHzsEvent && form.id > 0 && contactTypeId !== RESOLVER_CONTACT_TYPE_ID()" color="warning" @click="setAsResolver()">Nastavit na velitele zásahu</v-btn>
            <v-btn block v-if="$can('create', 'EventContact') && isHzsEvent && form.id > 0 && contactTypeId === RESOLVER_CONTACT_TYPE_ID()" color="warning" @click="unsetResolver()">Odebrat jako velitele zásahu</v-btn>
        </v-card-actions>
        <v-card-actions>
            <v-btn text @click="close()">Zavřít</v-btn>
            <v-btn v-if="canSms" @click="sendSms">Zaslat SMS</v-btn>
            <div class="flex-grow-1"></div>
            <v-btn color="error" v-if="canDelete" @click="remove">Smazat</v-btn>
            <v-btn color="success" v-if="canUpdate" @click="save">Uložit</v-btn>
            <v-btn color="success" v-if="canInsert" @click="save">Vytvořit</v-btn>
        </v-card-actions>
        <sms-form v-if="form.number" v-bind:event-id="eventId" v-bind:number="form.number" v-bind:name="form.name"
                  ref="smsForm"></sms-form>
    </v-card>
</template>

<script>

import contactCombobox from './ContactCombobox'
import smsForm from './SmsForm'
import {validationMixin} from "vuelidate";
import {integer, maxLength, minLength, required} from "vuelidate/lib/validators";
import {RESOLVER_CONTACT_TYPE_ID} from "@/store/modules/event/contacts";
import {mapGetters} from "vuex";

export default {
    name: 'sidebar-event-contact-form',
    mixins: [validationMixin],
    components: {
        contactCombobox,
        smsForm,
    },
    mounted() {
        this.form = {
            id: this.id,
            eventId: this.eventId,
            contactTypeId: this.contactTypeId,
            title: this.title,
            name: this.name,
            number: this.number ? this.number.toString() : '',
            custom: this.id ? this.custom : 1,
        }
    },
    data() {
        return {
            loading: false,
            form: {},
            message: false,
            hints: true,
        }
    },
    props: {
        header: {
            type: Boolean,
            required: false,
            default: true,
        },
        dark: {
            type: Boolean,
            required: false,
            default: true,
        },
        id: [Number, null],
        eventId: {
            type: Number,
            required: true,
        },
        contactTypeId: Number,
        setContactTypeId: [Number, null],
        contactTypeName: String,
        deviceCode: {
            type: String,
            default: '',
        },
        deviceId: Number,
        prefix: String,
        title: {
            type: [String, null],
            default: null,
        },
        name: {
            type: String,
            default: '&nbsp;',
        },
        suffix: String,
        number: {
            type: [Number, String],
            default: '',
        },
        code: String,
        type: String,
        icon: String,
        custom: Number,
        persistent: Number,
    },
    validations: {
        form: {
            name: {
                required,
            },
            number: {
                required,
                integer,
                minLength: minLength(9),
                maxLength: maxLength(9)
            }
        }
    },
    computed: {
        ...mapGetters('events', {
            getEventById: 'byId',
            getIsHzsEvent: 'isHzsEvent',
        }),
        event() {
            return this.getEventById(this.eventId);
        },
        isHzsEvent() {
            return this.getIsHzsEvent(this.event.eventCategoryId);
        },
        canChangeContent() {
            return this.custom === 1
        },
        canSms() {
            return this.form.id && this.form.number && (this.form.number.charAt(0) === '6' || this.form.number.charAt(0) === '7');
        },
        canUpdate() {
            return this.id > 0 && this.canChangeContent;
        },
        canInsert() {
            return this.id === null;
        },
        canDelete() {
            return this.id > 0 && this.persistent === 0 && this.custom === 1;
        },
        nameErrors() {
            const errors = []
            if (!this.$v.form.name.$dirty) return errors
            !this.$v.form.name.required && errors.push('Prosím vyplňte')
            return errors
        },
        numberErrors() {
            const errors = []
            if (!this.$v.form.number.$dirty) return errors
            !this.$v.form.number.required && errors.push('Prosím vyplňte')
            !this.$v.form.number.integer && errors.push('Toto pole musí obsahovat jen číslice')
            !this.$v.form.number.minLength && errors.push('Vložte devítimístné telefonní číslo')
            !this.$v.form.number.maxLength && errors.push('Vložte devítimístné telefonní číslo')
            return errors
        },
    },
    methods: {
        RESOLVER_CONTACT_TYPE_ID() {
            return RESOLVER_CONTACT_TYPE_ID
        },
        validate() {
            this.$v.form.$touch();
            if (this.$v.$invalid) {
                this.submitting = false;
                return false;
            }
            return true;
        },
        close() {
            this.$emit('onClose');
        },
        remove() {
            this.loading = true;
            this.$store.dispatch('eventContacts/remove', this.id).then(() => {
                this.close();
                this.loading = false;
            });
        },
        setAsResolver() {
            this.loading = true;

            if (!this.validate()) {
                this.loading = false;
                return;
            }

            this.form.contactTypeId = this.RESOLVER_CONTACT_TYPE_ID();
            this.form.title = 'Velitel zásahu';
            this.$store.dispatch('eventContacts/save', this.form).then(() => {
                this.close();
                this.loading = false;
            });
        },
        unsetResolver() {
            this.loading = true;

            if (!this.validate()) {
                this.loading = false;
                return;
            }

            if (this.deviceId) {
                this.form.contactTypeId = 5;
            } else {
                this.form.contactTypeId = 4;
            }

            this.form.title = null;
            this.$store.dispatch('eventContacts/save', this.form).then(() => {
                this.close();
                this.loading = false;
            });
        },
        save() {
            this.loading = true;

            if (!this.validate()) {
                this.loading = false;
                return;
            }

            if (this.setContactTypeId)
                this.form.contactTypeId = this.setContactTypeId;

            if (this.form.contactTypeId === undefined)
                this.form.contactTypeId = '';

            this.$store.dispatch('eventContacts/save', this.form).then(() => {
                this.close();
                this.loading = false;
            });
        },
        setName(item) {
            this.form.name = item.name;
        },
        setNumber(item) {
            this.form.number = item.number;
        },
        sendSms() {
            this.$refs.smsForm.open();
        },
    }
}
</script>
